/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
  AddressFromJSON,
  AddressFromJSONTyped,
  AddressToJSON,
  AddressToJSONTyped,
} from './Address';
import type { AppExtension } from './AppExtension';
import {
  AppExtensionFromJSON,
  AppExtensionFromJSONTyped,
  AppExtensionToJSON,
  AppExtensionToJSONTyped,
} from './AppExtension';
// import type { CourierSettingsStatusAlertOptions } from './CourierSettingsStatusAlertOptions';
import // CourierSettingsStatusAlertOptionsFromJSON,
// CourierSettingsStatusAlertOptionsFromJSONTyped,
// CourierSettingsStatusAlertOptionsToJSON,
// CourierSettingsStatusAlertOptionsToJSONTyped,
'./CourierSettingsStatusAlertOptions';
import type { ContactInformation } from './ContactInformation';
import {
  ContactInformationFromJSON,
  ContactInformationFromJSONTyped,
  ContactInformationToJSON,
  ContactInformationToJSONTyped,
} from './ContactInformation';
import type { Notification } from './Notification';
import {
  NotificationFromJSON,
  NotificationFromJSONTyped,
  NotificationToJSON,
  NotificationToJSONTyped,
} from './Notification';

/**
 *
 * @export
 * @interface CourierSettings
 */
export interface CourierSettings {
  /**
   *
   * @type {string}
   * @memberof CourierSettings
   */
  prefix?: string;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  useJmd?: boolean;
  /**
   * ISO-4217 currency code the courier operates in (e.g. 'JMD', 'USD', 'GBP').
   * When unset, callers derive it from `useJmd` (true -> 'JMD', else 'USD').
   * @type {string}
   * @memberof CourierSettings
   */
  currency?: string;
  /**
   * When true, cash-out requires recording the bill/coin denomination breakdown.
   * @type {boolean}
   * @memberof CourierSettings
   */
  isCashDenominationEnabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  showDualCurrency?: boolean;
  /**
   *
   * @type {number}
   * @memberof CourierSettings
   */
  exchangeRate?: number;
  /**
   *
   * @type {number}
   * @memberof CourierSettings
   */
  businessExchangeRate?: number;
  /**
   *
   * @type {number}
   * @memberof CourierSettings
   */
  gct?: number;
  /**
   *
   * @type {number}
   * @memberof CourierSettings
   */
  processingFee1?: number;
  /**
   *
   * @type {number}
   * @memberof CourierSettings
   */
  processingFee2?: number;
  /**
   *
   * @type {number}
   * @memberof CourierSettings
   */
  processingFee3?: number;
  /**
   *
   * @type {number}
   * @memberof CourierSettings
   */
  processingFee4?: number;
  /**
   * Type of processingFee1: 'fixed', 'percentage_value', or 'percentage_shipping'
   * @type {string}
   * @memberof CourierSettings
   */
  processingFee1Type?: string;
  /**
   * Type of processingFee2: 'fixed', 'percentage_value', or 'percentage_shipping'
   * @type {string}
   * @memberof CourierSettings
   */
  processingFee2Type?: string;
  /**
   * Type of processingFee3: 'fixed', 'percentage_value', or 'percentage_shipping'
   * @type {string}
   * @memberof CourierSettings
   */
  processingFee3Type?: string;
  /**
   * Type of processingFee4: 'fixed', 'percentage_value', or 'percentage_shipping'
   * @type {string}
   * @memberof CourierSettings
   */
  processingFee4Type?: string;
  /**
   *
   * @type {number}
   * @memberof CourierSettings
   */
  fixedCustomRate?: number;
  /**
   *
   * @type {Address}
   * @memberof CourierSettings
   */
  warehouseAddress?: Address;
  /**
   *
   * @type {Address}
   * @memberof CourierSettings
   */
  seaAddress?: Address;
  /**
   *
   * @type {Array<number>}
   * @memberof CourierSettings
   */
  weightPrice?: Array<number>;

  /**
   *
   * @type {Array<number>}
   * @memberof CourierSettings
   */
  expressWeightPrice?: Array<number>;
  /**
   *
   * @type {Address}
   * @memberof CourierSettings
   */
  storeAddress?: Address;
  /**
   *
   * @type {AppExtension}
   * @memberof CourierSettings
   */
  facebook?: AppExtension;
  /**
   *
   * @type {AppExtension}
   * @memberof CourierSettings
   */
  google?: AppExtension;
  /**
   *
   * @type {AppExtension}
   * @memberof CourierSettings
   */
  paypal?: AppExtension;
  /**
   *
   * @type {AppExtension}
   * @memberof CourierSettings
   */
  stripe?: AppExtension;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  referralEnabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  pointsEnabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  notificationEnabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  paymentsEnabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  pwaSupported?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  whatsappBotEnabled?: boolean;

  whatsappServerUrl?: string;

  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  useFixedCustomRate?: boolean;
  /**
   *
   * @type {string}
   * @memberof CourierSettings
   */
  calculatorType?: string;
  /**
   *
   * @type {ContactInformation}
   * @memberof CourierSettings
   */
  contactInformation?: ContactInformation;
  /**
   * Google Tag Manager container ID (e.g. GTM-XXXXXXX) injected into the
   * customer portal and marketing landing pages.
   * @type {string}
   * @memberof CourierSettings
   */
  gtmContainerId?: string;
  /**
   * When true, the marketing site links to its own /signup page instead of
   * redirecting to the courier's external hosting URL.
   * @type {boolean}
   * @memberof CourierSettings
   */
  isNativeSignupEnabled?: boolean;
  /**
   *
   * @type {string}
   * @memberof CourierSettings
   */
  publicVapidKey?: string;
  /**
   *
   * @type {string}
   * @memberof CourierSettings
   */
  privateVapidKey?: string;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  showInvoiceNotification?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  showAppNotification?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  seaShippingEnabled?: boolean;
  /**
   *
   * @type {Notification}
   * @memberof CourierSettings
   */
  invoiceNotification?: Notification;
  /**
   *
   * @type {Notification}
   * @memberof CourierSettings
   */
  appNotification?: Notification;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  useOutForDelivery?: boolean;
  /**
   *
   * @type {number}
   * @memberof CourierSettings
   */
  courierStartPrice?: number;
  /**
   *
   * @type {number}
   * @memberof CourierSettings
   */
  courierAdditionalLbPrice?: number;
  /**
   *
   * @type {Array<number>}
   * @memberof CourierSettings
   */
  staffWeightPrice?: Array<number>;
  /**
   *
   * @type {Array<number>}
   * @memberof CourierSettings
   */
  staffExpressWeightPrice?: Array<number>;
  /**
   *
   * @type {number}
   * @memberof CourierSettings
   */
  staffStartPrice?: number;
  /**
   *
   * @type {number}
   * @memberof CourierSettings
   */
  staffAdditionalLbPrice?: number;
  /**
   *
   * @type {number}
   * @memberof CourierSettings
   */
  staffExchangeRate?: number;
  /**
   *
   * @type {string}
   * @memberof CourierSettings
   */
  externalUrl?: string;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  useV2AddressFormat?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  isUploadEnabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  useMailboxNumber?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  useCouponCode?: boolean;
  /**
   *
   * @type {CourierSettingsStatusAlertOptions}
   * @memberof CourierSettings
   */
  statusAlertOptions?: string[];
  /**
   * Controls when status alerts are sent: 'automatic' or 'manual'
   * @type {string}
   * @memberof CourierSettings
   */
  statusAlertMode?: string;
  /**
   * When true, package status options are sourced from the courier's custom PackageStatus records instead of the defaults
   * @type {boolean}
   * @memberof CourierSettings
   */
  useCustomStatuses?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  useHalfPound?: boolean;
  /**
   *
   * @type {number}
   * @memberof CourierSettings
   */
  halfPoundPrice?: number;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  usePhoneOnSignup?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  useCpvLabProcess?: boolean;
  /**
   * Whether SpeedzMasterV2 API integration is enabled for this courier
   * @type {boolean}
   * @memberof CourierSettings
   */
  isSpeedzMasterV2ApiEnabled?: boolean;
  /**
   * API key for SpeedzMasterV2 API integration
   * @type {string}
   * @memberof CourierSettings
   */
  speedzMasterV2ApiKey?: string;
  /**
   * Courier ID for SpeedzMasterV2 API integration
   * @type {string}
   * @memberof CourierSettings
   */
  speedzMasterV2CourierId?: string;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  isJaShippersApiEnabled?: boolean;
  /**
   *
   * @type {string}
   * @memberof CourierSettings
   */
  jaShippersApiKey?: string;
  /**
   * Per-courier JaShippers address (e.g. https://oasc.jashippers.com)
   * @type {string}
   * @memberof CourierSettings
   */
  jaShippersApiBaseUrl?: string;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  isDeliveryEnabled?: boolean;
  /**
   *
   * @type {number}
   * @memberof CourierSettings
   */
  processingFeeWeightLimit?: number;
  /**
   *
   * @type {number}
   * @memberof CourierSettings
   */
  insuranceFee?: number;
  /**
   * Charged to the customer when a package's label was missing the courier
   * code (CourierPackage.isMislabeled) — passes the warehouse's charge on.
   * @type {number}
   * @memberof CourierSettings
   */
  missingCourierCodeFee?: number;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  isMultiLocationEnabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  isPreAlertSupported?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  isLocalDeliveryOnly?: boolean;
  /**
   *
   * @type {string}
   * @memberof CourierSettings
   */
  mailboxAddressFormat?: string;
  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  isMarketingEnabled?: boolean;
  /**
   *
   * @type {string}
   * @memberof CourierSettings
   */
  ezeePayLicenceKey?: string;
  /**
   * Whether late fees are enabled for this courier
   * @type {boolean}
   * @memberof CourierSettings
   */
  isLateFeeEnabled?: boolean;
  /**
   * Number of days after Ready status before a package is considered late
   * @type {number}
   * @memberof CourierSettings
   */
  lateFeeDays?: number;
  /**
   * Amount to charge per day for late packages
   * @type {number}
   * @memberof CourierSettings
   */
  lateFeeAmount?: number;
  /**
   * Number of days before late fee is applied to notify the customer
   * @type {number}
   * @memberof CourierSettings
   */
  notifyBeforeDays?: number;
  /**
   * Date from which late fees will be applied (ISO string format)
   * @type {string}
   * @memberof CourierSettings
   */
  lateFeeStartDate?: string;
  /**
   *
   * @type {number}
   * @memberof CourierSettings
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof CourierSettings
   */
  courierId?: number;

  isTasokoApiEnabled?: boolean;
  tasokoApiAccessToken?: string;
  /** Route this courier's WhatsApp through the self-hosted gateway instead of WASender. */
  isWhatsappGatewayEnabled?: boolean;
  isLogisApiEnabled?: boolean;
  logisApiAccessToken?: string;
  logisApiBaseUrl?: string;
  pricePerCubicFoot?: number;
  barrelPrice?: number;
  additionalShippingAddresses?: Address[];

  fygaroApiKey?: string;
  fygaroApiBaseUrl?: string;
  fygaroApiSecretKey?: string;
  fygaroServiceChargePercent?: number;
  stripeServiceChargePercent?: number;



  /**
   *
   * @type {boolean}
   * @memberof CourierSettings
   */
  isFygaroApiEnabled?: boolean;

  isSkgApiEnabled?: boolean;
  skgApiKey?: string;

  isShipCorpApiEnabled?: boolean;
  shipCorpApiAccessToken?: string;
  shipCorpApiBaseUrl?: string;

  isFarin2YaadApiEnabled?: boolean;
  farin2YaadApiKey?: string;
  farin2YaadApiBaseUrl?: string;

  isAtoraApiEnabled?: boolean;
  atoraApiKey?: string;
  atoraApiBaseUrl?: string;

  isScanInEnabled?: boolean;
  isSmartScanEnabled?: boolean;
  isSmartScanTwoStepEnabled?: boolean;
  /** SmartScan's big one-screen checklist, and the intake station's large-package path. */
  isSmartScanSimpleEnabled?: boolean;
  landingPageVersion?: string;
  isShipBizApiEnabled?: boolean;
  shipBizApiKey?: string;
  shipBizApiBaseUrl?: string;

  useWaApi?: boolean;
  isSmsApiEnabled?: boolean;
  /**
   * Passkey (WebAuthn) sign-in. Off by default: passkeys depend on the
   * courier's CourierResolver domains being correct, so each courier is
   * verified before being switched on.
   */
  isPasskeyEnabled?: boolean;
  turnstileSiteKey?: string;
  invoiceTemplate?: string;
  /**
   * Invoice generation mode: 'automatic' (generate per package on Ready), 'manual' (no auto-generation, for multi-package invoicing), 'consolidated' (auto-generate but allow consolidation)
   * @type {string}
   * @memberof CourierSettings
   */
  invoiceGenerationMode?: 'automatic' | 'manual' | 'consolidated';
  isWarehouseApiEnabled?: boolean;
  /**
   * Require linked sub-couriers (partners) to complete KYC before their packages can be processed. Warehouse-enabled couriers only.
   * @type {boolean}
   * @memberof CourierSettings
   */
  isPartnerKycRequired?: boolean;
  /**
   * Days a newly linked partner has to complete KYC before being blocked.
   * @type {number}
   * @memberof CourierSettings
   */
  partnerKycGraceDays?: number;
  /**
   * Default number of days a sent partner contract stays open for signature.
   * @type {number}
   * @memberof CourierSettings
   */
  partnerContractDefaultExpiryDays?: number;
  /**
   * Warehouse scan bonus: pay staff per package scanned "At Warehouse" beyond a daily target. Warehouse-enabled couriers only.
   * @type {boolean}
   * @memberof CourierSettings
   */
  scanBonusEnabled?: boolean;
  /**
   * Packages a worker must scan "At Warehouse" in a day before the bonus starts.
   * @type {number}
   * @memberof CourierSettings
   */
  scanBonusDailyTarget?: number;
  /**
   * Bonus amount (courier currency) per package scanned beyond the daily target.
   * @type {number}
   * @memberof CourierSettings
   */
  scanBonusPerPackage?: number;
  /**
   * Bonus per package beyond the daily target when the scan also included a contents photo. Falls back to scanBonusPerPackage when unset.
   * @type {number}
   * @memberof CourierSettings
   */
  scanBonusPerPackageWithContents?: number;
  /**
   * Scan-bonus payout mode. 'group': one team target = scanBonusDailyTarget x staff clocked in
   * that day, scans outside workStartTime-workEndTime excluded, pool split equally among everyone
   * clocked in. 'individual': per-worker target (legacy). Defaults to 'group'.
   * @type {string}
   * @memberof CourierSettings
   */
  scanBonusMode?: 'group' | 'individual';
  /**
   * Amount taken off the scan bonus per package that is reassigned to a different customer
   * or flagged unknown AFTER its At-Warehouse scan (off the day's pool in group mode, off the
   * scanner's day in individual mode; floored at 0). 0 = no deduction.
   * @type {number}
   * @memberof CourierSettings
   */
  scanBonusDeductionPerPackage?: number;
  isScanInCourierLockEnabled?: boolean;
  manifestCreationMode?: string;
  qualifyStripeLink?: string;
  qualifyStripeLinkBundle?: string;
  qualifyStripeLinkNonOx?: string;

  /**
   * Whether Wipay payment integration is enabled
   * @type {boolean}
   * @memberof CourierSettings
   */
  isWipayApiEnabled?: boolean;
  /**
   * Wipay API key for authentication
   * @type {string}
   * @memberof CourierSettings
   */
  wipayApiKey?: string;
  /**
   * Wipay account number
   * @type {string}
   * @memberof CourierSettings
   */
  wipayAccountNumber?: string;
  /**
   * Wipay country code
   * @type {string}
   * @memberof CourierSettings
   */
  wipayCountryCode?: string;
  /**
   * Wipay currency code
   * @type {string}
   * @memberof CourierSettings
   */
  wipayCurrency?: string;
  /**
   * Wipay response URL for callbacks
   * @type {string}
   * @memberof CourierSettings
   */
  wipayResponseUrl?: string;
  /**
   * Wipay environment (sandbox/production)
   * @type {string}
   * @memberof CourierSettings
   */
  wipayEnvironment?: string;
  /**
   * Wipay fee structure
   * @type {string}
   * @memberof CourierSettings
   */
  wipayFeeStructure?: string;
  /**
   * Wipay API base URL
   * @type {string}
   * @memberof CourierSettings
   */
  wipayApiBaseUrl?: string;
  requireVerification?: boolean;
  /**
   * Whether TRN (Tax Registration Number) is required during customer signup
   * @type {boolean}
   * @memberof CourierSettings
   */
  requireTrnOnSignup?: boolean;

  /**
   * Whether address is required during customer signup
   * @type {boolean}
   * @memberof CourierSettings
   */
  requireAddressOnSignup?: boolean;

  /**
   * Whether to ask "Were you referred by someone?" during customer signup
   * @type {boolean}
   * @memberof CourierSettings
   */
  isReferredByEnabled?: boolean;

  /**
   * Whether to ask "How did you hear about us?" during customer signup
   * @type {boolean}
   * @memberof CourierSettings
   */
  isReferralSourceEnabled?: boolean;

  /**
   * Courier-configurable "How did you hear about us?" options
   * @type {string[]}
   * @memberof CourierSettings
   */
  referralSourceOptions?: string[];

  /**
   * Whether push notifications are enabled for this courier
   * @type {boolean}
   * @memberof CourierSettings
   */
  isPushNotificationEnabled?: boolean;
  /**
   * Firebase Cloud Messaging server key
   * @type {string}
   * @memberof CourierSettings
   */
  fcmServerKey?: string;
  /**
   * Package statuses that should trigger push notifications
   * @type {string[]}
   * @memberof CourierSettings
   */
  pushNotificationStatusOptions?: string[];

  /**
   * Whether HNM integration is enabled for this courier
   * @type {boolean}
   * @memberof CourierSettings
   */
  isHnmApiEnabled?: boolean;
  /**
   * Whether the mobile app is enabled for this courier
   * @type {boolean}
   * @memberof CourierSettings
   */
  isAppEnabled?: boolean;
  /**
   * Whether mobile admin shell access is enabled (paid add-on)
   * @type {boolean}
   * @memberof CourierSettings
   */
  isMobileAdminEnabled?: boolean;
  /**
   * Whether Android app access is enabled for this courier
   * @type {boolean}
   * @memberof CourierSettings
   */
  isAndroidAppEnabled?: boolean;
  /**
   * Whether Shop For Me feature is enabled
   * @type {boolean}
   * @memberof CourierSettings
   */
  isLocalDeliveryEnabled?: boolean;
  isCustomerChatEnabled?: boolean;
  isShopForMeEnabled?: boolean;
  isFulfillmentEnabled?: boolean;
  /**
   * Whether Shop/Store feature is enabled
   * @type {boolean}
   * @memberof CourierSettings
   */
  isShopEnabled?: boolean;
  isBlogEnabled?: boolean;
  isPackageRequestsEnabled?: boolean;
  /**
   * Shop purchasing fee type (flat or percentage)
   * @type {string}
   * @memberof CourierSettings
   */
  shopPurchasingFeeType?: string;
  /**
   * Shop purchasing fee amount
   * @type {number}
   * @memberof CourierSettings
   */
  shopPurchasingFeeAmount?: number;
  /**
   * Order amount threshold for two-tier fee
   * @type {number}
   * @memberof CourierSettings
   */
  shopPurchasingFeeThreshold?: number;
  /**
   * Fee type for orders over threshold (flat or percentage)
   * @type {string}
   * @memberof CourierSettings
   */
  shopPurchasingFee2Type?: string;
  /**
   * Fee amount for orders over threshold
   * @type {number}
   * @memberof CourierSettings
   */
  shopPurchasingFee2Amount?: number;
  bankAccounts?: Array<{
    bankName: string;
    accountName: string;
    accountNumber: string;
    accountType?: string;
    branch?: string;
    notes?: string;
  }>;
  /**
   * Stripe subscription item ID for Android app addon
   * @type {string}
   * @memberof CourierSettings
   */
  androidAppSubscriptionItemId?: string;
  /**
   * Whether iOS app access is enabled for this courier
   * @type {boolean}
   * @memberof CourierSettings
   */
  isIosAppEnabled?: boolean;
  /**
   * Stripe subscription item ID for iOS app addon
   * @type {string}
   * @memberof CourierSettings
   */
  iosAppSubscriptionItemId?: string;
  /**
   * HNM portal username (e.g., HNM6576)
   * @type {string}
   * @memberof CourierSettings
   */
  hnmUsername?: string;
  /**
   * HNM portal password
   * @type {string}
   * @memberof CourierSettings
   */
  hnmPassword?: string;
  /**
   * URL of the HNM scraper microservice
   * @type {string}
   * @memberof CourierSettings
   */
  hnmScraperUrl?: string;
  /**
   * Whether attendance tracking is enabled for this courier
   * @type {boolean}
   * @memberof CourierSettings
   */
  attendanceEnabled?: boolean;
  /**
   * IANA timezone for this courier used for attendance day-bucketing and
   * time display (e.g. "America/Jamaica", "America/New_York"). Defaults to
   * "America/Jamaica" when unset.
   * @type {string}
   * @memberof CourierSettings
   */
  timezone?: string;
  /**
   * Whether payroll tracking is enabled for this courier
   * @type {boolean}
   * @memberof CourierSettings
   */
  payrollEnabled?: boolean;
  /**
   * Pay period type: weekly, biweekly, or monthly
   * @type {string}
   * @memberof CourierSettings
   */
  payPeriodType?: 'weekly' | 'biweekly' | 'monthly';
  /**
   * Day of week to start pay periods (0=Sunday, 1=Monday, etc.)
   * @type {number}
   * @memberof CourierSettings
   */
  payPeriodStartDay?: number;
  /**
   * Weekly hours threshold before overtime kicks in
   * @type {number}
   * @memberof CourierSettings
   */
  overtimeThresholdWeekly?: number;
  /**
   * Overtime pay multiplier (e.g., 1.5 for time-and-a-half)
   * @type {number}
   * @memberof CourierSettings
   */
  overtimeMultiplier?: number;
  /**
   * Whether to require staff to select a location when clocking in
   * @type {boolean}
   * @memberof CourierSettings
   */
  requireClockInLocation?: boolean;
  /**
   * Weight rounding mode for pricing calculations: 'up' (ceiling) or 'down' (floor)
   * @type {string}
   * @memberof CourierSettings
   */
  weightRoundingMode?: 'up' | 'down';
  /**
   * Whether Stripe payment integration is enabled
   * @type {boolean}
   * @memberof CourierSettings
   */
  isStripeApiEnabled?: boolean;
  /**
   * Stripe restricted API key (stored encrypted)
   * @type {string}
   * @memberof CourierSettings
   */
  restrictedKey?: string;
  /**
   * Whether Cargo JA API integration is enabled for this courier
   * @type {boolean}
   * @memberof CourierSettings
   */
  isCargoJaApiEnabled?: boolean;
  /**
   * API key for Cargo JA API integration
   * @type {string}
   * @memberof CourierSettings
   */
  cargoJaApiKey?: string;
  /**
   * Base URL for Cargo JA API integration
   * @type {string}
   * @memberof CourierSettings
   */
  cargoJaApiBaseUrl?: string;
  /**
   * Whether Sutherland Freight Logistics API integration is enabled
   * @type {boolean}
   * @memberof CourierSettings
   */
  isSflApiEnabled?: boolean;
  /**
   * API key for Sutherland Freight Logistics webhook integration
   * @type {string}
   * @memberof CourierSettings
   */
  sflApiKey?: string;
  /**
   * Whether OnePlus Courier JA API integration is enabled
   * @type {boolean}
   * @memberof CourierSettings
   */
  isOnePlusApiEnabled?: boolean;
  /**
   * Bearer token for fetching packages from OnePlus GET API
   * @type {string}
   * @memberof CourierSettings
   */
  onePlusApiKey?: string;
  /**
   * Bearer token OnePlus sends when pushing package data to our webhook
   * @type {string}
   * @memberof CourierSettings
   */
  onePlusWebhookKey?: string;
  /**
   * Base URL for OnePlus Courier JA API integration
   * @type {string}
   * @memberof CourierSettings
   */
  onePlusApiBaseUrl?: string;
  /**
   * Whether SSN Ship Courier Panel API integration is enabled
   * @type {boolean}
   * @memberof CourierSettings
   */
  isSsnApiEnabled?: boolean;
  /**
   * SSN partner API base URL
   * @type {string}
   * @memberof CourierSettings
   */
  ssnApiBaseUrl?: string;
  /**
   * X-CLIENT-ID for calling SSN partner API
   * @type {string}
   * @memberof CourierSettings
   */
  ssnClientId?: string;
  /**
   * X-API-KEY for calling SSN partner API (encrypted)
   * @type {string}
   * @memberof CourierSettings
   */
  ssnApiKey?: string;
  /**
   * Bearer token SSN uses when calling OX customer endpoints (encrypted)
   * @type {string}
   * @memberof CourierSettings
   */
  ssnPartnerApiToken?: string;
  /**
   * HMAC secret for validating SSN webhook signatures (encrypted)
   * @type {string}
   * @memberof CourierSettings
   */
  ssnWebhookSecret?: string;
  /**
   * Timestamp of last successful customer sync to SSN
   * @type {Date}
   * @memberof CourierSettings
   */
  ssnLastCustomerSyncAt?: Date;
  /**
   * Whether SCC (Shipping Company Core) Warehouse API integration is enabled
   * @type {boolean}
   * @memberof CourierSettings
   */
  isSccApiEnabled?: boolean;
  /**
   * SCC Warehouse API base URL
   * @type {string}
   * @memberof CourierSettings
   */
  sccApiBaseUrl?: string;
  /**
   * Bearer token for calling SCC Warehouse API (encrypted)
   * @type {string}
   * @memberof CourierSettings
   */
  sccApiToken?: string;
  /**
   * Shared key SCC sends in the Api-Key header when pushing packages to our webhook (encrypted)
   * @type {string}
   * @memberof CourierSettings
   */
  sccWebhookKey?: string;
  /**
   * Timestamp of last successful customer sync to SCC
   * @type {Date}
   * @memberof CourierSettings
   */
  sccLastCustomerSyncAt?: Date;
  /**
   * Whether the TR Global Logistics API integration is enabled
   * @type {boolean}
   * @memberof CourierSettings
   */
  isTrGlobalApiEnabled?: boolean;
  /**
   * TR Global API base URL
   * @type {string}
   * @memberof CourierSettings
   */
  trGlobalApiBaseUrl?: string;
  /**
   * Bearer token TR Global issued to us, for outbound calls to their API (encrypted)
   * @type {string}
   * @memberof CourierSettings
   */
  trGlobalApiToken?: string;
  /**
   * Bearer token we generate and hand to TR Global; they send it when pushing packages to our webhook (encrypted)
   * @type {string}
   * @memberof CourierSettings
   */
  trGlobalWebhookKey?: string;
  /**
   * Timestamp of last successful customer sync to TR Global
   * @type {Date}
   * @memberof CourierSettings
   */
  trGlobalLastCustomerSyncAt?: Date;
  /**
   * Whether receipt printer integration is enabled
   * @type {boolean}
   * @memberof CourierSettings
   */
  isReceiptPrinterEnabled?: boolean;
  /**
   * IP address of the ESC/POS receipt printer
   * @type {string}
   * @memberof CourierSettings
   */
  receiptPrinterIp?: string;
  /**
   * TCP port of the ESC/POS receipt printer
   * @type {number}
   * @memberof CourierSettings
   */
  receiptPrinterPort?: number;
  /**
   * Social media profile URLs for the courier
   * @type {{ facebook?: string; instagram?: string; tiktok?: string; twitter?: string; youtube?: string; linkedin?: string }}
   * @memberof CourierSettings
   */
  socialMedia?: {
    facebook?: string;
    instagram?: string;
    tiktok?: string;
    twitter?: string;
    youtube?: string;
    linkedin?: string;
  };
  /**
   * Whether the shipping calculator is enabled on the marketing website
   * @type {boolean}
   * @memberof CourierSettings
   */
  isCalculatorEnabled?: boolean;
  /** Customer reviews: portal submission + public reviews page/section on the landing site. */
  isReviewsEnabled?: boolean;
  /** Courier photo gallery: public gallery page/section on the landing site. */
  isGalleryEnabled?: boolean;
  /** Expense tracker (expenses, vendors, categories, reports) in the admin app. Default off. */
  isExpenseTrackerEnabled?: boolean;
  /** Warehouse Package Protection: AI coverage tiers, admin page, coverage fee lines on warehouse invoices. Default off. */
  isPackageProtectionEnabled?: boolean;
  /** Lets this warehouse's PartnerLinked couriers view and opt in/out of Package Protection. Default off. */
  isPackageProtectionSelfServeEnabled?: boolean;
  /** Customs estimate from an HS tariff code (landing + customer calculators, admin estimator). Estimate only. Default off. */
  isCustomsCalculatorEnabled?: boolean;
  /**
   * Read-only flags computed by the server: true when the matching secret column holds a value.
   * The secret values themselves are never returned. Only emitted when the secret column is
   * selected in the query `fields`. Never sent back by ToJSON.
   */
  hasAccountSid?: boolean;
  hasAirMeetsSeaApiKey?: boolean;
  hasAtoraApiKey?: boolean;
  hasAuthToken?: boolean;
  hasCargoJaApiKey?: boolean;
  hasEzeePayLicenceKey?: boolean;
  hasFarin2YaadApiKey?: boolean;
  hasFcmServerKey?: boolean;
  hasFcmServiceAccount?: boolean;
  hasFygaroApiKey?: boolean;
  hasFygaroApiSecretKey?: boolean;
  hasHnmPassword?: boolean;
  hasJaShippersApiKey?: boolean;
  hasLogisApiAccessToken?: boolean;
  hasOnePlusApiKey?: boolean;
  hasOnePlusWebhookKey?: boolean;
  hasPrivateVapidKey?: boolean;
  hasSccApiToken?: boolean;
  hasSccWebhookKey?: boolean;
  hasSflApiKey?: boolean;
  hasShipBizApiKey?: boolean;
  hasShipCorpApiAccessToken?: boolean;
  hasSkgApiKey?: boolean;
  hasSpeedMasterzApiKey?: boolean;
  hasSpeedzMasterV2ApiKey?: boolean;
  hasSsnApiKey?: boolean;
  hasSsnPartnerApiToken?: boolean;
  hasSsnWebhookSecret?: boolean;
  hasTasokoApiAccessToken?: boolean;
  hasTrGlobalApiToken?: boolean;
  hasTrGlobalWebhookKey?: boolean;
}

/**
 * Check if a given object implements the CourierSettings interface.
 */
export function instanceOfCourierSettings(
  value: object
): value is CourierSettings {
  return true;
}

export function CourierSettingsFromJSON(json: any): CourierSettings {
  return CourierSettingsFromJSONTyped(json, false);
}

export function CourierSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CourierSettings {
  if (json == null) {
    return json;
  }
  return {
    prefix: json['prefix'] == null ? undefined : json['prefix'],
    useJmd: json['useJmd'] == null ? undefined : json['useJmd'],
    currency: json['currency'] == null ? undefined : json['currency'],
    isCashDenominationEnabled: json['isCashDenominationEnabled'] == null ? undefined : json['isCashDenominationEnabled'],
    showDualCurrency: json['showDualCurrency'] == null ? undefined : json['showDualCurrency'],
    exchangeRate:
      json['exchangeRate'] == null ? undefined : json['exchangeRate'],
    businessExchangeRate:
      json['businessExchangeRate'] == null
        ? undefined
        : json['businessExchangeRate'],
    gct: json['gct'] == null ? undefined : json['gct'],
    processingFee1:
      json['processingFee1'] == null ? undefined : json['processingFee1'],
    processingFee2:
      json['processingFee2'] == null ? undefined : json['processingFee2'],
    processingFee3:
      json['processingFee3'] == null ? undefined : json['processingFee3'],
    processingFee4:
      json['processingFee4'] == null ? undefined : json['processingFee4'],
    processingFee1Type:
      json['processingFee1Type'] == null ? undefined : json['processingFee1Type'],
    processingFee2Type:
      json['processingFee2Type'] == null ? undefined : json['processingFee2Type'],
    processingFee3Type:
      json['processingFee3Type'] == null ? undefined : json['processingFee3Type'],
    processingFee4Type:
      json['processingFee4Type'] == null ? undefined : json['processingFee4Type'],
    fixedCustomRate:
      json['fixedCustomRate'] == null ? undefined : json['fixedCustomRate'],
    warehouseAddress:
      json['warehouseAddress'] == null
        ? undefined
        : AddressFromJSON(json['warehouseAddress']),
    seaAddress:
      json['seaAddress'] == null
        ? undefined
        : AddressFromJSON(json['seaAddress']),
    weightPrice: json['weightPrice'] == null ? undefined : json['weightPrice'],
    storeAddress:
      json['storeAddress'] == null
        ? undefined
        : AddressFromJSON(json['storeAddress']),
    facebook:
      json['facebook'] == null
        ? undefined
        : AppExtensionFromJSON(json['facebook']),
    google:
      json['google'] == null ? undefined : AppExtensionFromJSON(json['google']),
    paypal:
      json['paypal'] == null ? undefined : AppExtensionFromJSON(json['paypal']),
    stripe:
      json['stripe'] == null ? undefined : AppExtensionFromJSON(json['stripe']),
    referralEnabled:
      json['referralEnabled'] == null ? undefined : json['referralEnabled'],
    pointsEnabled:
      json['pointsEnabled'] == null ? undefined : json['pointsEnabled'],
    notificationEnabled:
      json['notificationEnabled'] == null
        ? undefined
        : json['notificationEnabled'],
    paymentsEnabled:
      json['paymentsEnabled'] == null ? undefined : json['paymentsEnabled'],
    pwaSupported:
      json['pwaSupported'] == null ? undefined : json['pwaSupported'],
    whatsappBotEnabled:
      json['whatsappBotEnabled'] == null
        ? undefined
        : json['whatsappBotEnabled'],
    useFixedCustomRate:
      json['useFixedCustomRate'] == null
        ? undefined
        : json['useFixedCustomRate'],
    calculatorType:
      json['calculatorType'] == null ? undefined : json['calculatorType'],
    contactInformation:
      json['contactInformation'] == null
        ? undefined
        : ContactInformationFromJSON(json['contactInformation']),
    gtmContainerId:
      json['gtmContainerId'] == null ? undefined : json['gtmContainerId'],
    isNativeSignupEnabled:
      json['isNativeSignupEnabled'] == null
        ? undefined
        : json['isNativeSignupEnabled'],
    publicVapidKey:
      json['publicVapidKey'] == null ? undefined : json['publicVapidKey'],
    privateVapidKey:
      json['privateVapidKey'] == null ? undefined : json['privateVapidKey'],
    showInvoiceNotification:
      json['showInvoiceNotification'] == null
        ? undefined
        : json['showInvoiceNotification'],
    showAppNotification:
      json['showAppNotification'] == null
        ? undefined
        : json['showAppNotification'],
    seaShippingEnabled:
      json['seaShippingEnabled'] == null
        ? undefined
        : json['seaShippingEnabled'],
    invoiceNotification:
      json['invoiceNotification'] == null
        ? undefined
        : NotificationFromJSON(json['invoiceNotification']),
    appNotification:
      json['appNotification'] == null
        ? undefined
        : NotificationFromJSON(json['appNotification']),
    useOutForDelivery:
      json['useOutForDelivery'] == null ? undefined : json['useOutForDelivery'],
    courierStartPrice:
      json['courierStartPrice'] == null ? undefined : json['courierStartPrice'],
    courierAdditionalLbPrice:
      json['courierAdditionalLbPrice'] == null
        ? undefined
        : json['courierAdditionalLbPrice'],
    staffWeightPrice:
      json['staffWeightPrice'] == null ? undefined : json['staffWeightPrice'],
    staffExpressWeightPrice:
      json['staffExpressWeightPrice'] == null
        ? undefined
        : json['staffExpressWeightPrice'],
    staffStartPrice:
      json['staffStartPrice'] == null ? undefined : json['staffStartPrice'],
    staffAdditionalLbPrice:
      json['staffAdditionalLbPrice'] == null
        ? undefined
        : json['staffAdditionalLbPrice'],
    staffExchangeRate:
      json['staffExchangeRate'] == null ? undefined : json['staffExchangeRate'],
    externalUrl: json['externalUrl'] == null ? undefined : json['externalUrl'],
    useV2AddressFormat:
      json['useV2AddressFormat'] == null
        ? undefined
        : json['useV2AddressFormat'],
    isUploadEnabled:
      json['isUploadEnabled'] == null ? undefined : json['isUploadEnabled'],
    useMailboxNumber:
      json['useMailboxNumber'] == null ? undefined : json['useMailboxNumber'],
    useCouponCode:
      json['useCouponCode'] == null ? undefined : json['useCouponCode'],
    statusAlertOptions:
      json['statusAlertOptions'] == null
        ? undefined
        : json['statusAlertOptions'],
    statusAlertMode:
      json['statusAlertMode'] == null
        ? undefined
        : json['statusAlertMode'],
    useCustomStatuses:
      json['useCustomStatuses'] == null
        ? undefined
        : json['useCustomStatuses'],
    useHalfPound:
      json['useHalfPound'] == null ? undefined : json['useHalfPound'],
    halfPoundPrice:
      json['halfPoundPrice'] == null ? undefined : json['halfPoundPrice'],
    usePhoneOnSignup:
      json['usePhoneOnSignup'] == null ? undefined : json['usePhoneOnSignup'],
    useCpvLabProcess:
      json['useCpvLabProcess'] == null ? undefined : json['useCpvLabProcess'],
    isSpeedzMasterV2ApiEnabled:
      json['isSpeedzMasterV2ApiEnabled'] == null
        ? undefined
        : json['isSpeedzMasterV2ApiEnabled'],
    speedzMasterV2ApiKey:
      json['speedzMasterV2ApiKey'] == null
        ? undefined
        : json['speedzMasterV2ApiKey'],
    speedzMasterV2CourierId:
      json['speedzMasterV2CourierId'] == null
        ? undefined
        : json['speedzMasterV2CourierId'],
    isJaShippersApiEnabled:
      json['isJaShippersApiEnabled'] == null
        ? undefined
        : json['isJaShippersApiEnabled'],
    jaShippersApiKey:
      json['jaShippersApiKey'] == null ? undefined : json['jaShippersApiKey'],
    jaShippersApiBaseUrl:
      json['jaShippersApiBaseUrl'] == null
        ? undefined
        : json['jaShippersApiBaseUrl'],
    isDeliveryEnabled:
      json['isDeliveryEnabled'] == null ? undefined : json['isDeliveryEnabled'],
    processingFeeWeightLimit:
      json['processingFeeWeightLimit'] == null
        ? undefined
        : json['processingFeeWeightLimit'],
    isMultiLocationEnabled:
      json['isMultiLocationEnabled'] == null
        ? undefined
        : json['isMultiLocationEnabled'],
    isPreAlertSupported:
      json['isPreAlertSupported'] == null
        ? undefined
        : json['isPreAlertSupported'],
    isLocalDeliveryOnly:
      json['isLocalDeliveryOnly'] == null
        ? undefined
        : json['isLocalDeliveryOnly'],
    mailboxAddressFormat:
      json['mailboxAddressFormat'] == null
        ? undefined
        : json['mailboxAddressFormat'],
    isMarketingEnabled:
      json['isMarketingEnabled'] == null
        ? undefined
        : json['isMarketingEnabled'],
    ezeePayLicenceKey:
      json['ezeePayLicenceKey'] == null ? undefined : json['ezeePayLicenceKey'],
    isLateFeeEnabled:
      json['isLateFeeEnabled'] == null ? undefined : json['isLateFeeEnabled'],
    lateFeeDays: json['lateFeeDays'] == null ? undefined : json['lateFeeDays'],
    lateFeeAmount:
      json['lateFeeAmount'] == null ? undefined : json['lateFeeAmount'],
    notifyBeforeDays:
      json['notifyBeforeDays'] == null ? undefined : json['notifyBeforeDays'],
    lateFeeStartDate:
      json['lateFeeStartDate'] == null ? undefined : json['lateFeeStartDate'],
    id: json['id'] == null ? undefined : json['id'],
    courierId: json['courierId'] == null ? undefined : json['courierId'],
    isTasokoApiEnabled:
      json['isTasokoApiEnabled'] == null
        ? undefined
        : json['isTasokoApiEnabled'],
    isWhatsappGatewayEnabled:
      json['isWhatsappGatewayEnabled'] == null
        ? undefined
        : json['isWhatsappGatewayEnabled'],
    tasokoApiAccessToken:
      json['tasokoApiAccessToken'] == null
        ? undefined
        : json['tasokoApiAccessToken'],
    isLogisApiEnabled:
      json['isLogisApiEnabled'] == null ? undefined : json['isLogisApiEnabled'],
    logisApiAccessToken:
      json['logisApiAccessToken'] == null
        ? undefined
        : json['logisApiAccessToken'],
    logisApiBaseUrl:
      json['logisApiBaseUrl'] == null ? undefined : json['logisApiBaseUrl'],
    insuranceFee:
      json['insuranceFee'] == null ? undefined : json['insuranceFee'],
    missingCourierCodeFee:
      json['missingCourierCodeFee'] == null ? undefined : json['missingCourierCodeFee'],
    pricePerCubicFoot:
      json['pricePerCubicFoot'] == null ? undefined : json['pricePerCubicFoot'],
    additionalShippingAddresses:
      json['additionalShippingAddresses'] == null
        ? undefined
        : json['additionalShippingAddresses'].map((item: any) =>
            AddressFromJSON(item)
          ),
    fygaroApiKey:
      json['fygaroApiKey'] == null ? undefined : json['fygaroApiKey'],
    fygaroApiBaseUrl:
      json['fygaroApiBaseUrl'] == null ? undefined : json['fygaroApiBaseUrl'],
    fygaroApiSecretKey:
      json['fygaroApiSecretKey'] == null
        ? undefined
        : json['fygaroApiSecretKey'],
    isFygaroApiEnabled:
      json['isFygaroApiEnabled'] == null
        ? undefined
        : json['isFygaroApiEnabled'],
    fygaroServiceChargePercent:
      json['fygaroServiceChargePercent'] == null ? undefined : json['fygaroServiceChargePercent'],
    stripeServiceChargePercent:
      json['stripeServiceChargePercent'] == null ? undefined : json['stripeServiceChargePercent'],
    barrelPrice: json['barrelPrice'] == null ? undefined : json['barrelPrice'],
    whatsappServerUrl:
      json['whatsappServerUrl'] == null ? undefined : json['whatsappServerUrl'],
    isSkgApiEnabled:
      json['isSkgApiEnabled'] == null ? undefined : json['isSkgApiEnabled'],
    skgApiKey: json['skgApiKey'] == null ? undefined : json['skgApiKey'],
    isShipCorpApiEnabled:
      json['isShipCorpApiEnabled'] == null
        ? undefined
        : json['isShipCorpApiEnabled'],
    shipCorpApiAccessToken:
      json['shipCorpApiAccessToken'] == null
        ? undefined
        : json['shipCorpApiAccessToken'],
    shipCorpApiBaseUrl:
      json['shipCorpApiBaseUrl'] == null
        ? undefined
        : json['shipCorpApiBaseUrl'],
    isFarin2YaadApiEnabled:
      json['isFarin2YaadApiEnabled'] == null
        ? undefined
        : json['isFarin2YaadApiEnabled'],
    farin2YaadApiKey:
      json['farin2YaadApiKey'] == null ? undefined : json['farin2YaadApiKey'],
    farin2YaadApiBaseUrl:
      json['farin2YaadApiBaseUrl'] == null
        ? undefined
        : json['farin2YaadApiBaseUrl'],
    isAtoraApiEnabled:
      json['isAtoraApiEnabled'] == null ? undefined : json['isAtoraApiEnabled'],
    atoraApiKey: json['atoraApiKey'] == null ? undefined : json['atoraApiKey'],
    atoraApiBaseUrl:
      json['atoraApiBaseUrl'] == null ? undefined : json['atoraApiBaseUrl'],
    isScanInEnabled:
      json['isScanInEnabled'] == null ? undefined : json['isScanInEnabled'],
    isSmartScanEnabled:
      json['isSmartScanEnabled'] == null ? undefined : json['isSmartScanEnabled'],
    isSmartScanTwoStepEnabled:
      json['isSmartScanTwoStepEnabled'] == null
        ? undefined
        : json['isSmartScanTwoStepEnabled'],
    isSmartScanSimpleEnabled:
      json['isSmartScanSimpleEnabled'] == null
        ? undefined
        : json['isSmartScanSimpleEnabled'],
    landingPageVersion:
      json['landingPageVersion'] == null
        ? undefined
        : json['landingPageVersion'],
    isShipBizApiEnabled:
      json['isShipBizApiEnabled'] == null
        ? undefined
        : json['isShipBizApiEnabled'],
    shipBizApiKey:
      json['shipBizApiKey'] == null ? undefined : json['shipBizApiKey'],
    shipBizApiBaseUrl:
      json['shipBizApiBaseUrl'] == null ? undefined : json['shipBizApiBaseUrl'],
    useWaApi: json['useWaApi'] == null ? undefined : json['useWaApi'],
    expressWeightPrice:
      json['expressWeightPrice'] == null
        ? undefined
        : json['expressWeightPrice'],
    invoiceTemplate:
      json['invoiceTemplate'] == null ? undefined : json['invoiceTemplate'],
    invoiceGenerationMode:
      json['invoiceGenerationMode'] == null ? 'automatic' : json['invoiceGenerationMode'],
    isWipayApiEnabled:
      json['isWipayApiEnabled'] == null ? undefined : json['isWipayApiEnabled'],
    wipayApiKey: json['wipayApiKey'] == null ? undefined : json['wipayApiKey'],
    wipayAccountNumber:
      json['wipayAccountNumber'] == null
        ? undefined
        : json['wipayAccountNumber'],
    wipayCountryCode:
      json['wipayCountryCode'] == null ? undefined : json['wipayCountryCode'],
    wipayCurrency:
      json['wipayCurrency'] == null ? undefined : json['wipayCurrency'],
    wipayResponseUrl:
      json['wipayResponseUrl'] == null ? undefined : json['wipayResponseUrl'],
    wipayEnvironment:
      json['wipayEnvironment'] == null ? undefined : json['wipayEnvironment'],
    wipayFeeStructure:
      json['wipayFeeStructure'] == null ? undefined : json['wipayFeeStructure'],
    wipayApiBaseUrl:
      json['wipayApiBaseUrl'] == null ? undefined : json['wipayApiBaseUrl'],
    requireVerification:
      json['requireVerification'] == null
        ? undefined
        : json['requireVerification'],
    requireTrnOnSignup:
      json['requireTrnOnSignup'] == null
        ? undefined
        : json['requireTrnOnSignup'],
    requireAddressOnSignup:
      json['requireAddressOnSignup'] == null
        ? undefined
        : json['requireAddressOnSignup'],
    isReferredByEnabled:
      json['isReferredByEnabled'] == null
        ? undefined
        : json['isReferredByEnabled'],
    isReferralSourceEnabled:
      json['isReferralSourceEnabled'] == null
        ? undefined
        : json['isReferralSourceEnabled'],
    referralSourceOptions:
      json['referralSourceOptions'] == null
        ? undefined
        : json['referralSourceOptions'],
    isWarehouseApiEnabled:
      json['isWarehouseApiEnabled'] == null
        ? undefined
        : json['isWarehouseApiEnabled'],
    isPartnerKycRequired:
      json['isPartnerKycRequired'] == null
        ? undefined
        : json['isPartnerKycRequired'],
    partnerKycGraceDays:
      json['partnerKycGraceDays'] == null
        ? undefined
        : json['partnerKycGraceDays'],
    partnerContractDefaultExpiryDays:
      json['partnerContractDefaultExpiryDays'] == null
        ? undefined
        : json['partnerContractDefaultExpiryDays'],
    scanBonusEnabled:
      json['scanBonusEnabled'] == null ? undefined : json['scanBonusEnabled'],
    scanBonusDailyTarget:
      json['scanBonusDailyTarget'] == null
        ? undefined
        : json['scanBonusDailyTarget'],
    scanBonusPerPackage:
      json['scanBonusPerPackage'] == null
        ? undefined
        : json['scanBonusPerPackage'],
    scanBonusPerPackageWithContents:
      json['scanBonusPerPackageWithContents'] == null
        ? undefined
        : json['scanBonusPerPackageWithContents'],
    scanBonusMode:
      json['scanBonusMode'] == null ? undefined : json['scanBonusMode'],
    scanBonusDeductionPerPackage:
      json['scanBonusDeductionPerPackage'] == null
        ? undefined
        : json['scanBonusDeductionPerPackage'],
    isScanInCourierLockEnabled:
      json['isScanInCourierLockEnabled'] == null
        ? undefined
        : json['isScanInCourierLockEnabled'],
    manifestCreationMode:
      json['manifestCreationMode'] == null
        ? undefined
        : json['manifestCreationMode'],
    qualifyStripeLink:
      json['qualifyStripeLink'] == null
        ? undefined
        : json['qualifyStripeLink'],
    qualifyStripeLinkBundle:
      json['qualifyStripeLinkBundle'] == null
        ? undefined
        : json['qualifyStripeLinkBundle'],
    qualifyStripeLinkNonOx:
      json['qualifyStripeLinkNonOx'] == null
        ? undefined
        : json['qualifyStripeLinkNonOx'],
    isSmsApiEnabled:
      json['isSmsApiEnabled'] == null ? undefined : json['isSmsApiEnabled'],
    isPasskeyEnabled:
      json['isPasskeyEnabled'] == null ? undefined : json['isPasskeyEnabled'],
    turnstileSiteKey:
      json['turnstileSiteKey'] == null ? undefined : json['turnstileSiteKey'],
    isPushNotificationEnabled:
      json['isPushNotificationEnabled'] == null
        ? undefined
        : json['isPushNotificationEnabled'],
    fcmServerKey:
      json['fcmServerKey'] == null ? undefined : json['fcmServerKey'],
    pushNotificationStatusOptions:
      json['pushNotificationStatusOptions'] == null
        ? undefined
        : json['pushNotificationStatusOptions'],
    isHnmApiEnabled:
      json['isHnmApiEnabled'] == null ? undefined : json['isHnmApiEnabled'],
    isAppEnabled:
      json['isAppEnabled'] == null ? undefined : json['isAppEnabled'],
    isMobileAdminEnabled:
      json['isMobileAdminEnabled'] == null ? undefined : json['isMobileAdminEnabled'],
    isAndroidAppEnabled:
      json['isAndroidAppEnabled'] == null ? undefined : json['isAndroidAppEnabled'],
    isLocalDeliveryEnabled:
      json['isLocalDeliveryEnabled'] == null ? undefined : json['isLocalDeliveryEnabled'],
    isCustomerChatEnabled:
      json['isCustomerChatEnabled'] == null ? undefined : json['isCustomerChatEnabled'],
    isShopForMeEnabled:
      json['isShopForMeEnabled'] == null ? undefined : json['isShopForMeEnabled'],
    isFulfillmentEnabled:
      json['isFulfillmentEnabled'] == null ? undefined : json['isFulfillmentEnabled'],
    isShopEnabled:
      json['isShopEnabled'] == null ? undefined : json['isShopEnabled'],
    isBlogEnabled:
      json['isBlogEnabled'] == null ? undefined : json['isBlogEnabled'],
    isPackageRequestsEnabled:
      json['isPackageRequestsEnabled'] == null ? undefined : json['isPackageRequestsEnabled'],
    shopPurchasingFeeType:
      json['shopPurchasingFeeType'] == null ? undefined : json['shopPurchasingFeeType'],
    shopPurchasingFeeAmount:
      json['shopPurchasingFeeAmount'] == null ? undefined : json['shopPurchasingFeeAmount'],
    shopPurchasingFeeThreshold:
      json['shopPurchasingFeeThreshold'] == null ? undefined : json['shopPurchasingFeeThreshold'],
    shopPurchasingFee2Type:
      json['shopPurchasingFee2Type'] == null ? undefined : json['shopPurchasingFee2Type'],
    shopPurchasingFee2Amount:
      json['shopPurchasingFee2Amount'] == null ? undefined : json['shopPurchasingFee2Amount'],
    bankAccounts: json['bankAccounts'] == null ? undefined : json['bankAccounts'],
    androidAppSubscriptionItemId:
      json['androidAppSubscriptionItemId'] == null ? undefined : json['androidAppSubscriptionItemId'],
    isIosAppEnabled:
      json['isIosAppEnabled'] == null ? undefined : json['isIosAppEnabled'],
    iosAppSubscriptionItemId:
      json['iosAppSubscriptionItemId'] == null ? undefined : json['iosAppSubscriptionItemId'],
    hnmUsername:
      json['hnmUsername'] == null ? undefined : json['hnmUsername'],
    hnmPassword:
      json['hnmPassword'] == null ? undefined : json['hnmPassword'],
    hnmScraperUrl:
      json['hnmScraperUrl'] == null ? undefined : json['hnmScraperUrl'],
    attendanceEnabled:
      json['attendanceEnabled'] == null ? undefined : json['attendanceEnabled'],
    timezone:
      json['timezone'] == null ? undefined : json['timezone'],
    payrollEnabled:
      json['payrollEnabled'] == null ? undefined : json['payrollEnabled'],
    payPeriodType:
      json['payPeriodType'] == null ? undefined : json['payPeriodType'],
    payPeriodStartDay:
      json['payPeriodStartDay'] == null ? undefined : json['payPeriodStartDay'],
    overtimeThresholdWeekly:
      json['overtimeThresholdWeekly'] == null ? undefined : json['overtimeThresholdWeekly'],
    overtimeMultiplier:
      json['overtimeMultiplier'] == null ? undefined : json['overtimeMultiplier'],
    requireClockInLocation:
      json['requireClockInLocation'] == null ? undefined : json['requireClockInLocation'],
    weightRoundingMode:
      json['weightRoundingMode'] == null ? 'up' : json['weightRoundingMode'],
    isStripeApiEnabled:
      json['isStripeApiEnabled'] == null ? undefined : json['isStripeApiEnabled'],
    restrictedKey:
      json['restrictedKey'] == null ? undefined : json['restrictedKey'],
    isCargoJaApiEnabled:
      json['isCargoJaApiEnabled'] == null ? undefined : json['isCargoJaApiEnabled'],
    cargoJaApiKey:
      json['cargoJaApiKey'] == null ? undefined : json['cargoJaApiKey'],
    cargoJaApiBaseUrl:
      json['cargoJaApiBaseUrl'] == null ? undefined : json['cargoJaApiBaseUrl'],
    isSflApiEnabled:
      json['isSflApiEnabled'] == null ? undefined : json['isSflApiEnabled'],
    sflApiKey:
      json['sflApiKey'] == null ? undefined : json['sflApiKey'],
    isOnePlusApiEnabled:
      json['isOnePlusApiEnabled'] == null ? undefined : json['isOnePlusApiEnabled'],
    onePlusApiKey:
      json['onePlusApiKey'] == null ? undefined : json['onePlusApiKey'],
    onePlusWebhookKey:
      json['onePlusWebhookKey'] == null ? undefined : json['onePlusWebhookKey'],
    onePlusApiBaseUrl:
      json['onePlusApiBaseUrl'] == null ? undefined : json['onePlusApiBaseUrl'],
    isSsnApiEnabled:
      json['isSsnApiEnabled'] == null ? undefined : json['isSsnApiEnabled'],
    ssnApiBaseUrl:
      json['ssnApiBaseUrl'] == null ? undefined : json['ssnApiBaseUrl'],
    ssnClientId:
      json['ssnClientId'] == null ? undefined : json['ssnClientId'],
    ssnApiKey:
      json['ssnApiKey'] == null ? undefined : json['ssnApiKey'],
    ssnPartnerApiToken:
      json['ssnPartnerApiToken'] == null ? undefined : json['ssnPartnerApiToken'],
    ssnWebhookSecret:
      json['ssnWebhookSecret'] == null ? undefined : json['ssnWebhookSecret'],
    ssnLastCustomerSyncAt:
      json['ssnLastCustomerSyncAt'] == null ? undefined : new Date(json['ssnLastCustomerSyncAt']),
    isSccApiEnabled:
      json['isSccApiEnabled'] == null ? undefined : json['isSccApiEnabled'],
    sccApiBaseUrl:
      json['sccApiBaseUrl'] == null ? undefined : json['sccApiBaseUrl'],
    sccApiToken:
      json['sccApiToken'] == null ? undefined : json['sccApiToken'],
    sccWebhookKey:
      json['sccWebhookKey'] == null ? undefined : json['sccWebhookKey'],
    sccLastCustomerSyncAt:
      json['sccLastCustomerSyncAt'] == null ? undefined : new Date(json['sccLastCustomerSyncAt']),
    isTrGlobalApiEnabled:
      json['isTrGlobalApiEnabled'] == null ? undefined : json['isTrGlobalApiEnabled'],
    trGlobalApiBaseUrl:
      json['trGlobalApiBaseUrl'] == null ? undefined : json['trGlobalApiBaseUrl'],
    trGlobalApiToken:
      json['trGlobalApiToken'] == null ? undefined : json['trGlobalApiToken'],
    trGlobalWebhookKey:
      json['trGlobalWebhookKey'] == null ? undefined : json['trGlobalWebhookKey'],
    trGlobalLastCustomerSyncAt:
      json['trGlobalLastCustomerSyncAt'] == null ? undefined : new Date(json['trGlobalLastCustomerSyncAt']),
    isReceiptPrinterEnabled:
      json['isReceiptPrinterEnabled'] == null ? undefined : json['isReceiptPrinterEnabled'],
    receiptPrinterIp:
      json['receiptPrinterIp'] == null ? undefined : json['receiptPrinterIp'],
    receiptPrinterPort:
      json['receiptPrinterPort'] == null ? undefined : json['receiptPrinterPort'],
    socialMedia:
      json['socialMedia'] == null ? undefined : json['socialMedia'],
    isCalculatorEnabled:
      json['isCalculatorEnabled'] == null ? undefined : json['isCalculatorEnabled'],
    isReviewsEnabled:
      json['isReviewsEnabled'] == null ? undefined : json['isReviewsEnabled'],
    isGalleryEnabled:
      json['isGalleryEnabled'] == null ? undefined : json['isGalleryEnabled'],
    isExpenseTrackerEnabled:
      json['isExpenseTrackerEnabled'] == null
        ? undefined
        : json['isExpenseTrackerEnabled'],
    isPackageProtectionEnabled:
      json['isPackageProtectionEnabled'] == null
        ? undefined
        : json['isPackageProtectionEnabled'],
    isPackageProtectionSelfServeEnabled:
      json['isPackageProtectionSelfServeEnabled'] == null
        ? undefined
        : json['isPackageProtectionSelfServeEnabled'],
    isCustomsCalculatorEnabled:
      json['isCustomsCalculatorEnabled'] == null
        ? undefined
        : json['isCustomsCalculatorEnabled'],
    hasAccountSid: json['hasAccountSid'] == null ? undefined : json['hasAccountSid'],
    hasAirMeetsSeaApiKey: json['hasAirMeetsSeaApiKey'] == null ? undefined : json['hasAirMeetsSeaApiKey'],
    hasAtoraApiKey: json['hasAtoraApiKey'] == null ? undefined : json['hasAtoraApiKey'],
    hasAuthToken: json['hasAuthToken'] == null ? undefined : json['hasAuthToken'],
    hasCargoJaApiKey: json['hasCargoJaApiKey'] == null ? undefined : json['hasCargoJaApiKey'],
    hasEzeePayLicenceKey: json['hasEzeePayLicenceKey'] == null ? undefined : json['hasEzeePayLicenceKey'],
    hasFarin2YaadApiKey: json['hasFarin2YaadApiKey'] == null ? undefined : json['hasFarin2YaadApiKey'],
    hasFcmServerKey: json['hasFcmServerKey'] == null ? undefined : json['hasFcmServerKey'],
    hasFcmServiceAccount: json['hasFcmServiceAccount'] == null ? undefined : json['hasFcmServiceAccount'],
    hasFygaroApiKey: json['hasFygaroApiKey'] == null ? undefined : json['hasFygaroApiKey'],
    hasFygaroApiSecretKey: json['hasFygaroApiSecretKey'] == null ? undefined : json['hasFygaroApiSecretKey'],
    hasHnmPassword: json['hasHnmPassword'] == null ? undefined : json['hasHnmPassword'],
    hasJaShippersApiKey: json['hasJaShippersApiKey'] == null ? undefined : json['hasJaShippersApiKey'],
    hasLogisApiAccessToken: json['hasLogisApiAccessToken'] == null ? undefined : json['hasLogisApiAccessToken'],
    hasOnePlusApiKey: json['hasOnePlusApiKey'] == null ? undefined : json['hasOnePlusApiKey'],
    hasOnePlusWebhookKey: json['hasOnePlusWebhookKey'] == null ? undefined : json['hasOnePlusWebhookKey'],
    hasPrivateVapidKey: json['hasPrivateVapidKey'] == null ? undefined : json['hasPrivateVapidKey'],
    hasSccApiToken: json['hasSccApiToken'] == null ? undefined : json['hasSccApiToken'],
    hasSccWebhookKey: json['hasSccWebhookKey'] == null ? undefined : json['hasSccWebhookKey'],
    hasSflApiKey: json['hasSflApiKey'] == null ? undefined : json['hasSflApiKey'],
    hasShipBizApiKey: json['hasShipBizApiKey'] == null ? undefined : json['hasShipBizApiKey'],
    hasShipCorpApiAccessToken: json['hasShipCorpApiAccessToken'] == null ? undefined : json['hasShipCorpApiAccessToken'],
    hasSkgApiKey: json['hasSkgApiKey'] == null ? undefined : json['hasSkgApiKey'],
    hasSpeedMasterzApiKey: json['hasSpeedMasterzApiKey'] == null ? undefined : json['hasSpeedMasterzApiKey'],
    hasSpeedzMasterV2ApiKey: json['hasSpeedzMasterV2ApiKey'] == null ? undefined : json['hasSpeedzMasterV2ApiKey'],
    hasSsnApiKey: json['hasSsnApiKey'] == null ? undefined : json['hasSsnApiKey'],
    hasSsnPartnerApiToken: json['hasSsnPartnerApiToken'] == null ? undefined : json['hasSsnPartnerApiToken'],
    hasSsnWebhookSecret: json['hasSsnWebhookSecret'] == null ? undefined : json['hasSsnWebhookSecret'],
    hasTasokoApiAccessToken: json['hasTasokoApiAccessToken'] == null ? undefined : json['hasTasokoApiAccessToken'],
    hasTrGlobalApiToken: json['hasTrGlobalApiToken'] == null ? undefined : json['hasTrGlobalApiToken'],
    hasTrGlobalWebhookKey: json['hasTrGlobalWebhookKey'] == null ? undefined : json['hasTrGlobalWebhookKey'],
  };
}

export function CourierSettingsToJSON(json: any): CourierSettings {
  return CourierSettingsToJSONTyped(json, false);
}

export function CourierSettingsToJSONTyped(
  value?: CourierSettings | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    prefix: value['prefix'],
    useJmd: value['useJmd'],
    currency: value['currency'],
    isCashDenominationEnabled: value['isCashDenominationEnabled'],
    showDualCurrency: value['showDualCurrency'],
    exchangeRate: value['exchangeRate'],
    businessExchangeRate: value['businessExchangeRate'],
    gct: value['gct'],
    processingFee1: value['processingFee1'],
    processingFee2: value['processingFee2'],
    processingFee3: value['processingFee3'],
    processingFee4: value['processingFee4'],
    processingFee1Type: value['processingFee1Type'],
    processingFee2Type: value['processingFee2Type'],
    processingFee3Type: value['processingFee3Type'],
    processingFee4Type: value['processingFee4Type'],
    fixedCustomRate: value['fixedCustomRate'],
    warehouseAddress: AddressToJSON(value['warehouseAddress']),
    seaAddress: AddressToJSON(value['seaAddress']),
    weightPrice: value['weightPrice'],
    expressWeightPrice: value['expressWeightPrice'],
    storeAddress: AddressToJSON(value['storeAddress']),
    facebook: AppExtensionToJSON(value['facebook']),
    google: AppExtensionToJSON(value['google']),
    paypal: AppExtensionToJSON(value['paypal']),
    stripe: AppExtensionToJSON(value['stripe']),
    referralEnabled: value['referralEnabled'],
    pointsEnabled: value['pointsEnabled'],
    notificationEnabled: value['notificationEnabled'],
    paymentsEnabled: value['paymentsEnabled'],
    pwaSupported: value['pwaSupported'],
    whatsappBotEnabled: value['whatsappBotEnabled'],
    useFixedCustomRate: value['useFixedCustomRate'],
    calculatorType: value['calculatorType'],
    contactInformation: ContactInformationToJSON(value['contactInformation']),
    gtmContainerId: value['gtmContainerId'],
    isNativeSignupEnabled: value['isNativeSignupEnabled'],
    publicVapidKey: value['publicVapidKey'],
    privateVapidKey: value['privateVapidKey'],
    showInvoiceNotification: value['showInvoiceNotification'],
    showAppNotification: value['showAppNotification'],
    seaShippingEnabled: value['seaShippingEnabled'],
    invoiceNotification: NotificationToJSON(value['invoiceNotification']),
    appNotification: NotificationToJSON(value['appNotification']),
    useOutForDelivery: value['useOutForDelivery'],
    courierStartPrice: value['courierStartPrice'],
    courierAdditionalLbPrice: value['courierAdditionalLbPrice'],
    staffWeightPrice: value['staffWeightPrice'],
    staffExpressWeightPrice: value['staffExpressWeightPrice'],
    staffStartPrice: value['staffStartPrice'],
    staffAdditionalLbPrice: value['staffAdditionalLbPrice'],
    staffExchangeRate: value['staffExchangeRate'],
    externalUrl: value['externalUrl'],
    useV2AddressFormat: value['useV2AddressFormat'],
    isUploadEnabled: value['isUploadEnabled'],
    useMailboxNumber: value['useMailboxNumber'],
    useCouponCode: value['useCouponCode'],
    statusAlertOptions: value['statusAlertOptions'],
    statusAlertMode: value['statusAlertMode'],
    useCustomStatuses: value['useCustomStatuses'],
    useHalfPound: value['useHalfPound'],
    halfPoundPrice: value['halfPoundPrice'],
    usePhoneOnSignup: value['usePhoneOnSignup'],
    useCpvLabProcess: value['useCpvLabProcess'],
    isSpeedzMasterV2ApiEnabled: value['isSpeedzMasterV2ApiEnabled'],
    speedzMasterV2ApiKey: value['speedzMasterV2ApiKey'],
    speedzMasterV2CourierId: value['speedzMasterV2CourierId'],
    isJaShippersApiEnabled: value['isJaShippersApiEnabled'],
    jaShippersApiKey: value['jaShippersApiKey'],
    jaShippersApiBaseUrl: value['jaShippersApiBaseUrl'],
    isDeliveryEnabled: value['isDeliveryEnabled'],
    processingFeeWeightLimit: value['processingFeeWeightLimit'],
    isMultiLocationEnabled: value['isMultiLocationEnabled'],
    isPreAlertSupported: value['isPreAlertSupported'],
    isLocalDeliveryOnly: value['isLocalDeliveryOnly'],
    mailboxAddressFormat: value['mailboxAddressFormat'],
    isMarketingEnabled: value['isMarketingEnabled'],
    ezeePayLicenceKey: value['ezeePayLicenceKey'],
    isLateFeeEnabled: value['isLateFeeEnabled'],
    lateFeeDays: value['lateFeeDays'],
    lateFeeAmount: value['lateFeeAmount'],
    notifyBeforeDays: value['notifyBeforeDays'],
    lateFeeStartDate: value['lateFeeStartDate'],
    id: value['id'],
    courierId: value['courierId'],
    isTasokoApiEnabled: value['isTasokoApiEnabled'],
    isWhatsappGatewayEnabled: value['isWhatsappGatewayEnabled'],
    tasokoApiAccessToken: value['tasokoApiAccessToken'],
    isLogisApiEnabled: value['isLogisApiEnabled'],
    logisApiAccessToken: value['logisApiAccessToken'],
    logisApiBaseUrl: value['logisApiBaseUrl'],
    insuranceFee: value['insuranceFee'],
    missingCourierCodeFee: value['missingCourierCodeFee'],
    pricePerCubicFoot: value['pricePerCubicFoot'],
    additionalShippingAddresses:
      value['additionalShippingAddresses'] == null
        ? undefined
        : value['additionalShippingAddresses'].map((item: any) =>
            AddressToJSON(item)
          ),
    fygaroApiKey: value['fygaroApiKey'],
    fygaroApiBaseUrl: value['fygaroApiBaseUrl'],
    fygaroApiSecretKey: value['fygaroApiSecretKey'],
    isFygaroApiEnabled: value['isFygaroApiEnabled'],
    fygaroServiceChargePercent: value['fygaroServiceChargePercent'],
    stripeServiceChargePercent: value['stripeServiceChargePercent'],
    barrelPrice: value['barrelPrice'],
    whatsappServerUrl: value['whatsappServerUrl'],
    isSkgApiEnabled: value['isSkgApiEnabled'],
    skgApiKey: value['skgApiKey'],
    isShipCorpApiEnabled: value['isShipCorpApiEnabled'],
    shipCorpApiAccessToken: value['shipCorpApiAccessToken'],
    shipCorpApiBaseUrl: value['shipCorpApiBaseUrl'],
    isFarin2YaadApiEnabled: value['isFarin2YaadApiEnabled'],
    farin2YaadApiKey: value['farin2YaadApiKey'],
    farin2YaadApiBaseUrl: value['farin2YaadApiBaseUrl'],
    isAtoraApiEnabled: value['isAtoraApiEnabled'],
    atoraApiKey: value['atoraApiKey'],
    atoraApiBaseUrl: value['atoraApiBaseUrl'],
    isScanInEnabled: value['isScanInEnabled'],
    isSmartScanEnabled: value['isSmartScanEnabled'],
    isSmartScanTwoStepEnabled: value['isSmartScanTwoStepEnabled'],
    isSmartScanSimpleEnabled: value['isSmartScanSimpleEnabled'],
    landingPageVersion: value['landingPageVersion'],
    isShipBizApiEnabled: value['isShipBizApiEnabled'],
    shipBizApiKey: value['shipBizApiKey'],
    shipBizApiBaseUrl: value['shipBizApiBaseUrl'],
    useWaApi: value['useWaApi'],
    isSmsApiEnabled: value['isSmsApiEnabled'],
    isPasskeyEnabled: value['isPasskeyEnabled'],
    turnstileSiteKey: value['turnstileSiteKey'],
    invoiceTemplate: value['invoiceTemplate'],
    invoiceGenerationMode: value['invoiceGenerationMode'],
    isWipayApiEnabled: value['isWipayApiEnabled'],
    wipayApiKey: value['wipayApiKey'],
    wipayAccountNumber: value['wipayAccountNumber'],
    wipayCountryCode: value['wipayCountryCode'],
    wipayCurrency: value['wipayCurrency'],
    wipayResponseUrl: value['wipayResponseUrl'],
    wipayEnvironment: value['wipayEnvironment'],
    wipayFeeStructure: value['wipayFeeStructure'],
    wipayApiBaseUrl: value['wipayApiBaseUrl'],
    requireVerification: value['requireVerification'],
    requireTrnOnSignup: value['requireTrnOnSignup'],
    requireAddressOnSignup: value['requireAddressOnSignup'],
    isReferredByEnabled: value['isReferredByEnabled'],
    isReferralSourceEnabled: value['isReferralSourceEnabled'],
    referralSourceOptions: value['referralSourceOptions'],
    isWarehouseApiEnabled: value['isWarehouseApiEnabled'],
    isPartnerKycRequired: value['isPartnerKycRequired'],
    partnerKycGraceDays: value['partnerKycGraceDays'],
    partnerContractDefaultExpiryDays: value['partnerContractDefaultExpiryDays'],
    scanBonusEnabled: value['scanBonusEnabled'],
    scanBonusDailyTarget: value['scanBonusDailyTarget'],
    scanBonusPerPackage: value['scanBonusPerPackage'],
    scanBonusPerPackageWithContents: value['scanBonusPerPackageWithContents'],
    scanBonusMode: value['scanBonusMode'],
    scanBonusDeductionPerPackage: value['scanBonusDeductionPerPackage'],
    isScanInCourierLockEnabled: value['isScanInCourierLockEnabled'],
    manifestCreationMode: value['manifestCreationMode'],
    qualifyStripeLink: value['qualifyStripeLink'],
    qualifyStripeLinkBundle: value['qualifyStripeLinkBundle'],
    qualifyStripeLinkNonOx: value['qualifyStripeLinkNonOx'],
    isPushNotificationEnabled: value['isPushNotificationEnabled'],
    fcmServerKey: value['fcmServerKey'],
    pushNotificationStatusOptions: value['pushNotificationStatusOptions'],
    isHnmApiEnabled: value['isHnmApiEnabled'],
    isAppEnabled: value['isAppEnabled'],
    isMobileAdminEnabled: value['isMobileAdminEnabled'],
    isAndroidAppEnabled: value['isAndroidAppEnabled'],
    isLocalDeliveryEnabled: value['isLocalDeliveryEnabled'],
    isCustomerChatEnabled: value['isCustomerChatEnabled'],
    isShopForMeEnabled: value['isShopForMeEnabled'],
    isFulfillmentEnabled: value['isFulfillmentEnabled'],
    isShopEnabled: value['isShopEnabled'],
    isBlogEnabled: value['isBlogEnabled'],
    isPackageRequestsEnabled: value['isPackageRequestsEnabled'],
    shopPurchasingFeeType: value['shopPurchasingFeeType'],
    shopPurchasingFeeAmount: value['shopPurchasingFeeAmount'],
    shopPurchasingFeeThreshold: value['shopPurchasingFeeThreshold'],
    shopPurchasingFee2Type: value['shopPurchasingFee2Type'],
    shopPurchasingFee2Amount: value['shopPurchasingFee2Amount'],
    bankAccounts: value['bankAccounts'],
    androidAppSubscriptionItemId: value['androidAppSubscriptionItemId'],
    isIosAppEnabled: value['isIosAppEnabled'],
    iosAppSubscriptionItemId: value['iosAppSubscriptionItemId'],
    hnmUsername: value['hnmUsername'],
    hnmPassword: value['hnmPassword'],
    hnmScraperUrl: value['hnmScraperUrl'],
    attendanceEnabled: value['attendanceEnabled'],
    timezone: value['timezone'],
    payrollEnabled: value['payrollEnabled'],
    payPeriodType: value['payPeriodType'],
    payPeriodStartDay: value['payPeriodStartDay'],
    overtimeThresholdWeekly: value['overtimeThresholdWeekly'],
    overtimeMultiplier: value['overtimeMultiplier'],
    requireClockInLocation: value['requireClockInLocation'],
    weightRoundingMode: value['weightRoundingMode'],
    isStripeApiEnabled: value['isStripeApiEnabled'],
    restrictedKey: value['restrictedKey'],
    isCargoJaApiEnabled: value['isCargoJaApiEnabled'],
    cargoJaApiKey: value['cargoJaApiKey'],
    cargoJaApiBaseUrl: value['cargoJaApiBaseUrl'],
    isSflApiEnabled: value['isSflApiEnabled'],
    sflApiKey: value['sflApiKey'],
    isOnePlusApiEnabled: value['isOnePlusApiEnabled'],
    onePlusApiKey: value['onePlusApiKey'],
    onePlusWebhookKey: value['onePlusWebhookKey'],
    onePlusApiBaseUrl: value['onePlusApiBaseUrl'],
    isSsnApiEnabled: value['isSsnApiEnabled'],
    ssnApiBaseUrl: value['ssnApiBaseUrl'],
    ssnClientId: value['ssnClientId'],
    ssnApiKey: value['ssnApiKey'],
    ssnPartnerApiToken: value['ssnPartnerApiToken'],
    ssnWebhookSecret: value['ssnWebhookSecret'],
    ssnLastCustomerSyncAt: value['ssnLastCustomerSyncAt'] == null ? undefined : (value['ssnLastCustomerSyncAt'] as Date).toISOString(),
    isSccApiEnabled: value['isSccApiEnabled'],
    sccApiBaseUrl: value['sccApiBaseUrl'],
    sccApiToken: value['sccApiToken'],
    sccWebhookKey: value['sccWebhookKey'],
    sccLastCustomerSyncAt: value['sccLastCustomerSyncAt'] == null ? undefined : (value['sccLastCustomerSyncAt'] as Date).toISOString(),
    isTrGlobalApiEnabled: value['isTrGlobalApiEnabled'],
    trGlobalApiBaseUrl: value['trGlobalApiBaseUrl'],
    trGlobalApiToken: value['trGlobalApiToken'],
    trGlobalWebhookKey: value['trGlobalWebhookKey'],
    trGlobalLastCustomerSyncAt: value['trGlobalLastCustomerSyncAt'] == null ? undefined : (value['trGlobalLastCustomerSyncAt'] as Date).toISOString(),
    isReceiptPrinterEnabled: value['isReceiptPrinterEnabled'],
    receiptPrinterIp: value['receiptPrinterIp'],
    receiptPrinterPort: value['receiptPrinterPort'],
    socialMedia: value['socialMedia'],
    isCalculatorEnabled: value['isCalculatorEnabled'],
    isReviewsEnabled: value['isReviewsEnabled'],
    isGalleryEnabled: value['isGalleryEnabled'],
    isExpenseTrackerEnabled: value['isExpenseTrackerEnabled'],
    isPackageProtectionEnabled: value['isPackageProtectionEnabled'],
    isPackageProtectionSelfServeEnabled: value['isPackageProtectionSelfServeEnabled'],
    isCustomsCalculatorEnabled: value['isCustomsCalculatorEnabled'],
  };
}
